<template>
  <div id="app">
    <router-view></router-view>
    <div class="load-imgs">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/chaoren_normal.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/chaoren_champion.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/chaoren_correct.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/chaoren_cry.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/chaoren_speak.png" alt="">

      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/meidui_normal.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/meidui_champion.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/meidui_correct.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/meidui_cry.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/meidui_speak.png" alt="">

      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/gtx_normal.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/gtx_champion.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/gtx_correct.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/gtx_cry.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/gtx_speak.png" alt="">

      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll4_normal.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll4_champion.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll4_correct.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll4_cry.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll4_speak.png" alt="">

      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll5_normal.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll5_champion.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll5_correct.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll5_cry.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll5_speak.png" alt="">

      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll6_normal.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll6_champion.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll6_correct.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll6_cry.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll6_speak.png" alt="">

      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll7_normal.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll7_champion.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll7_correct.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll7_cry.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll7_speak.png" alt="">

      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll8_normal.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll8_champion.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll8_correct.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll8_cry.png" alt="">
      <img src="https://cdn.spbcn.org/Fengyong/Images/mifeng/ll8_speak.png" alt="">

    </div>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
  }
}
</script>

<style lang="less">
.load-imgs{
  width: 200px;
  height: 100px;
  position: fixed;
  left: -220px;
  img{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
  }
}
</style>
